import { Component, OnInit } from '@angular/core';
import { BookinglinkService } from '../bookinglink.service';
import { CommonService } from '../../../services/common.service';
import jspdf from 'jspdf'
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { NotesmodalComponent } from '../notesmodal/notesmodal.component';
import { BookingimageComponent } from '../bookingimage/bookingimage.component';
import { PdppopupviewComponent } from '../../pdfpersection/pdppopupview-modal/pdppopupview.component';
import { environment } from '../../../../environments/environment';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-overdue7-days',
    templateUrl: './overdue7-days.component.html',
    styleUrls: ['./overdue7-days.component.sass']
})

export class Overdue7DaysComponent implements OnInit {
    loader = true;
    items: any;
    pdfdata: any;
    pdfviewer: any;
    listData: any;
    p = 1;
    nodata = false;
    iswarranty: any;
    deleteid: any;
    searchText = "";
    query: any = {
        page: 1,
        limit: environment.defaultPageSize,
        userType: 1,
    };
    recordsPerPage: number;
    totalRecords = 0;
    APIEndpoint = "";
    APIENDPOINTFORCSV = ""


    constructor(
        private booking: BookinglinkService,
        private modalService: BsModalService,
        private commonService: CommonService
    ) {
        this.recordsPerPage = environment.defaultPageSize;
        this.APIEndpoint = environment.CLIENTEndpoint;
        this.APIENDPOINTFORCSV = environment.APIEndpoint

    }

    private searchTerms = new Subject<string>();
    ngOnInit() {
        this.getbookinglist("7 days Overdue");
        this.getpdfpopup("Overdue");
        this.pdfviewer = false;
        this.listData = [
            "Profile Preparation",
            "Dates Sent",
            "Job Underway",
            "Job On Hold",
            "Job Cancelled",
            "To be Invoiced",
            "Awaiting Payment",
            "Dispute or On Hold",
            "Paid in full",
        ];
        this.searchTerms
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((value) => {
                this.query.search = value;
                this.pageChanged({ page: 1 });
                // this.engineerlist();
            });
    }

    getValue(event: Event): void {
        const inputElement = event.target as HTMLInputElement;
        this.searchTerms.next(inputElement.value);
        // return (event.target as HTMLInputElement).value;
    }
    getpdfpopup(obj) {
        this.booking.getpdfforsectionbyname(obj).subscribe(
            (result: any) => {
                const items = result.data;
                this.pdfdata = items;
                console.log(this.pdfdata);
            },
            (error: any) => {
                // this.commonService.toast(error.error.message, 'Error');
            }
        );
    }

    getbookinglist(obj) {
        this.query.search = this.searchText;
        this.booking.getbookingListV2(obj, this.query).subscribe(
            (result: any) => {
                // console.log(result,"cresi")
                const record = result.data.data;
                console.log(record, "cresi")
                this.totalRecords = result.data.totalCount;
                this.items = record;
                this.loader = false;
                this.nodata = false;
            },
            (error: any) => {
                this.loader = false;
                this.nodata = true;
                // this.commonService.toast(error.error.message, 'Error');
            }
        );
    }

    pageChanged(event: any): void {
        this.p = event.page;
        this.query.page = this.p;
        this.getbookinglist("7 days Overdue");
    }

    uploadfile(userid) {
        const initialState = {
            userid: userid,
        };
        this.modalService.show(BookingimageComponent, {
            initialState,
            class: "modal-lg",
        });
        this.modalService.onHide.subscribe(() => { });
    }
    pdfshow() {
        const initialState = {
            pdf: this.pdfdata.PDF,
        };
        this.modalService.show(PdppopupviewComponent, {
            initialState,
            class: "modal-lg",
        });
        this.modalService.onHide.subscribe(() => { });
    }

    notesModal(userid, uid) {
        //console.log(userid);
        const initialState = {
            userid: userid,
            uId: uid,
        };
        this.modalService.show(NotesmodalComponent, {
            initialState,
            class: "modal-lg",
        });
        this.modalService.onHide.subscribe(() => { });
    }

    deltedata() {
        const Id = this.deleteid;
        this.booking.deleteData(Id).subscribe(
            (result: any) => {
                this.loader = false;
                if (result.success === true) {
                    this.commonService.toast(result.message, "Success");
                } else {
                    this.commonService.toast(result.message, "Error");
                }
                this.getbookinglist("7 days Overdue");
            },
            (error: any) => {
                this.loader = false;
                this.commonService.toast(error.error.message, "Error");
            }
        );
    }
    changeStatus(_id, event) {
        const status = event.target.value;
        this.booking.updateStatus({ _id, status: status }).subscribe(
            (result: any) => {
                this.commonService.toast(
                    `Booking status updated successfully.`,
                    "Success"
                );
                this.getbookinglist("7day_overdue");
            },
            (error) => {
                this.commonService.toast(error.error.message, "Error");
            }
        );
    }
    async downloadpdf(base64String, firsttime) {
        if (firsttime == false) {
            this.loader = true;
            var imgWidth = 210;
            var pageHeight = 280;
            var imgHeight = 530; //canvas.height * imgWidth / canvas.width;
            var heightLeft = imgHeight;

            var pdf = new jspdf("p", "mm");
            var position = 0;

            pdf.addImage(
                base64String,
                "PNG",
                0,
                position,
                imgWidth,
                imgHeight + 25
            );
            heightLeft -= pageHeight;

            // while (heightLeft >= 0) {
            position = heightLeft - imgHeight - 5;
            pdf.addPage();
            pdf.addImage(base64String, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            //}
            await pdf.save("PDF/Buildfix_Booking_Details.pdf");
            this.loader = false;
        } else if (firsttime == true) {
            this.loader = true;
            var imgWidth = 210;
            var pageHeight = 280;
            var imgHeight = 530; //canvas.height * imgWidth / canvas.width;
            var heightLeft = imgHeight;

            var pdf = new jspdf("p", "mm");
            var position = 0;

            pdf.addImage(
                base64String,
                "PNG",
                0,
                position,
                imgWidth,
                imgHeight + 5
            );
            heightLeft -= pageHeight;

            //while (heightLeft >= 0) {
            position = heightLeft - imgHeight - 13;
            pdf.addPage();
            pdf.addImage(base64String, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            //}
            await pdf.save("PDF/Buildfix_Booking_Details.pdf");
            this.loader = false;
        }
    }

    saveid(Id) {
        this.deleteid = Id;
    }
    exportAsXLSX(): void {

        const status = encodeURIComponent("7 days Overdue"); // encodes the space
        const url = this.APIENDPOINTFORCSV + '/' + 'users/generate-csv-for-booking/' + status;


        const newTab = window.open(url, '_blank');

        console.log("url:", url)
        if (newTab) {
            newTab.onload = () => {

                newTab.location.href = url;  // This triggers the download if the server is set up correctly
            };
        } else {
            console.error('Could not open new tab');
        }
    }
}